import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import AWSSecurityHubCredentialsForm from "./AWSSecurityHubCredentialsForm";
import AWSSecurityHubMappingForm from "./AWSSecurityHubMappingForm";
import { columnRenderArrayData } from "utils/tableUtils";

const AWSSecurityHubConfigListing = (props) => {
  const columns = [
    {
      title: "AWS Account",
      dataIndex: "awsAccount",
      width: 130,
      render: (awsAccount) =>
        awsAccount ? columnRenderArrayData(awsAccount) : "All",
    },
    {
      title: "Region",
      dataIndex: "region",
      width: 100,
    },
    {
      title: "AWS Product",
      dataIndex: "awsProduct",
      render: (awsProduct) =>
        awsProduct ? columnRenderArrayData(awsProduct) : "All",
      width: 100,
    },
  ];

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={AWSSecurityHubMappingForm}
      CredentialsForm={AWSSecurityHubCredentialsForm}
      extraColumns={columns}
      triggerModifyParam={triggerModifyParam}
      displayComponentName={"AWS Account"}
    />
  );
};

export default AWSSecurityHubConfigListing;

const triggerModifyParam = (record) => {
  return {
    toolConfigId: record.id,
  };
};
